// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"461":"polyfills","799":"app-init"}[chunkId] || chunkId) + "." + {"34":"e7fd6c35","461":"9439632f","799":"4f2c8882","964":"5836fd4c"}[chunkId] + ".chunk.js";
};